import React from 'react'
import Pagination from './Button'

function CreatePagination ({data, selected, handlePagination}) {
    
    //create an array that can hold a number of chunks based on the given data
    //and will be used to create pagination buttons
    const array = data && data.filter((x , index) => index % 10 === 0)
   
    return(
      <>
      { 
        array && array.map((x, index) => 
          <Pagination 
            style={{backgroundColor: selected === index  ? '#E7E9EB'  : '', padding:'0.9vh 0.8rem', margin:'0.1rem'}}
            key={index + 1} 
            name={index + 1}
            className='pagination'
            selected={selected}
            handleClick={(e) => handlePagination(e.target.id)}
          />
        )
      }
    </>
    )
  }
  export default CreatePagination